import { USERTYPES } from "../../../constants/Constants";
import { encrypt } from "../../../helpers/AESUtility";
import { encryptData } from "../../../helpers/RSAUtility";

export const firmDataModal = (values, state, role, formattedAutoAssignModality, hospitalCheckList, pacsNodeList, showPriorsStudiesList) => {
  const encryptedName = encryptData(values.name);
  const encryptedAddress = encryptData(values.address);
  const encryptedCountry = encryptData(values.country);
  const encryptedState = encryptData(values.state);
  const encryptedCity = encryptData(values.city);
  const encryptedPriority_studies = values.priorityStudies;
  const contact1Name = encryptData(values.contact1.name);
  const contact1Email = encryptData(values.contact1.email);
  const contact1Type = encryptData(values.contact1.type);
  const contact1Mobile = encryptData(values.contact1.mobile);
  const contact1Landline = encryptData(values.contact1.landline);
  const signature2Text = encryptData(values.signature2Dto.signatureText);
  const signature3Text = encryptData(values.signature3Dto.signatureText);
  const accountWarning = encryptData(values.accountWarning);
  const customerSupportNumber=encryptData(values.customerSupportNumber);

  let contact1Flag = true;
  let contact2Flag = true;
  let contact3Flag = true;
  if (
    values.contact1.name == "" &&
    values.contact1.email == "" &&
    values.contact1.type == "" &&
    values.contact1.mobile == "" &&
    values.contact1.landline == ""
  ) {
    contact1Flag = false;
  }
  if (
    values.contact2.name == "" &&
    values.contact2.email == "" &&
    values.contact2.type == "" &&
    values.contact2.mobile == "" &&
    values.contact2.landline == ""
  ) {
    contact2Flag = false;
  }
  if (
    values.contact3.name == "" &&
    values.contact3.email == "" &&
    values.contact3.type == "" &&
    values.contact3.mobile == "" &&
    values.contact3.landline == ""
  ) {
    contact3Flag = false;
  }

  const contact2Name = encryptData(values.contact2.name);
  const contact2Email = encryptData(values.contact2.email);
  const contact2Type = encryptData(values.contact2.type);
  const contact2Mobile = encryptData(values.contact2.mobile);
  const contact2Landline = encryptData(values.contact2.landline);

  const contact3Name = encryptData(values.contact3.name);
  const contact3Email = encryptData(values.contact3.email);
  const contact3Type = encryptData(values.contact3.type);
  const contact3Mobile = encryptData(values.contact3.mobile);
  const contact3Landline = encryptData(values.contact3.landline);

  const firmDto = {
    name: encryptedName,
    address: encryptedAddress,
    country: encryptedCountry,
    state: encryptedState,
    city: encryptedCity,
    customerSupportNumber:customerSupportNumber,
    priorityStudies: encryptedPriority_studies,
    active: values.active,
    password_protected: values.password_protected,
    firmType: values.firmType,
    firmRole: role === USERTYPES.ADMIN ? null : values.firmRole,
    triageCTStudies: false,
    triageXRAYStudies: values.triageXRAYStudies,
    addTimeToReport: values.addTimeToReport ? 1 : 0,
    addDateToReport: values.addDateToReport ? 1 : 0,
    addSupervisorSignature: values.addSupervisorSignature,
    accountWarning: accountWarning,
    isDOC: values.isDOC ? 1 : 0,
    isDOCX: values.isDOCX ? 1 : 0,
    isPDF: values.isPDF ? 1 : 0,
    isPDFWithImage: values.isPDFWithImage ? 1 : 0,
    isPDFWithKeyImage: values.isPDFWithKeyImage ? 1 : 0,
    isDOCXWithKeyImage: values.isDOCXWithKeyImage ? 1 : 0,
    qcEnabled: values.qcEnabled ? 1 : 0,
    twoSignaturesAllowed: values.twoSignaturesAllowed ? 1 : 0,
    modalityIds: values.modalityIds,
    autoAssignEnable: values.autoAssignEnable ? 1 : 0,
    autoAssignModalityIds: values.autoAssignModalityIds,
    addPrintDisclaimer: values.addPrintDisclaimer,
    printDisclaimerText: values.printDisclaimerText,
    addendumDisclaimerEnabled: values.addendumDisclaimerEnabled,
    addendumDisclaimerText: values.addendumDisclaimerText,
    historyAvailable: values.historyAvailable,
    reportHeaderDto: {
      headerImage: values.reportHeaderDto.headerImage,
      footerImage: values.reportHeaderDto.footerImage,
      headerImageUrl: values.reportHeaderDto.headerImageUrl,
      footerImageUrl: values.reportHeaderDto.footerImageUrl,
      isHeaderImageDeleted: values.reportHeaderDto.isHeaderImageDeleted ? 1 : 0,
      isFooterImageDeleted: values.reportHeaderDto.isFooterImageDeleted ? 1 : 0
    },
    signature2Dto: {
      signatureText: signature2Text,
      signatureImage: values.signature2Dto.signatureFile2,
      isSignatureImageDeleted: values.signature2Dto.isSignatureImageDeleted ? 1 : 0
    },
    signature3Dto: {
      signatureText: signature3Text,
      signatureImage: values.signature3Dto.signatureFile3,
      isSignatureImageDeleted: values.signature3Dto.isSignatureImageDeleted ? 1 : 0
    },
    studyLinkExpiryTime: values.studyLinkExpiryTime,
    enableShareReportLink: values.enableShareReportLink,
    reportLinkExpiryTime: values.reportLinkExpiryTime,
    accountWarning: values.accountWarning,
    updatedTimeString: values.updatedTimeString,
    schemeCode: values.schemeCode,
    autoAssignModalityIds: values.autoAssignModalityIds,
    autoAssignEnable: values.autoAssignEnable ? 1 : 0,
    exactMatchEnabled: values.exactMatchEnable ? values.exactMatchEnable: false,
    pediatricAssignmentEnabled: values.pediatricAssignmentEnabled ? 1 : 0,
    selectedPediatricModalityId: values.selectedPediatricModalityId,
    autoAssignModalityWithSubModalityIds: formattedAutoAssignModality(),
    historyAvailable: values.historyAvailable,
    isClientWarning: values.isClientWarning,
    addendumDisclaimerEnabled: values.addendumDisclaimerEnabled,
    addendumDisclaimerText: values.addendumDisclaimerText,
    allowDownloadStudy: values.allowDownloadStudy,
    allowDownloadReport: values.allowDownloadReport,
    enableQRCodeInReport: values.enableQRCodeInReport,
    enableStudySharingLinkInReport: values.enableStudySharingLinkInReport,
    enableUnassignmentService: values.enableUnassignmentService,
    reqBlankLines: values.reqBlankLines,
    reqBlankLinesAfterHeader:values.reqBlankLinesAfterHeader,
    priorityCount: values.priorityCount,
    firmIdList: hospitalCheckList,
    headerTextLine1: values.headerTextLine1,
    headerTextLine2: values.headerTextLine2,
    isFirmPacsReceiver: values.isFirmPacsReceiver,
    branchCode: values.branchCode,
    showWord: values.showWord,
    selectedSubModalityListNumber: values.selectedSubModalityListNumber,
    firmIdList: hospitalCheckList,
    pacsNodeList: pacsNodeList,
    showPriorsConnectionDtoList: showPriorsStudiesList,
    showPriorsStudies: values.showPriorsStudies,
    cxrVersionViewer: values.cxrVersionViewer,
    cxrVersionStudyList: values.cxrVersionStudyList,  
    boneEnabled: values.boneEnabled,
    showFindings : values.showFindings,
    showProbability : values.showProbability,
    subtleFindings: values.subtleFindings,
    showPriorsStudies: values.showPriorsStudies,
    showAboveThresholdScore: values.showAboveThresholdScore,
    enableGenkiStudyInference : values.enableGenkiStudyInference,
    enableSecondaryCapture: values.enableSecondaryCapture
  };
  if (contact1Flag) {
    firmDto["contact1"] = {
      name: contact1Name,
      email: contact1Email,
      type: contact1Type,
      mobile: contact1Mobile,
      landline: contact1Landline,
    };
  }
  if (contact2Flag) {
    firmDto["contact2"] = {
      name: contact2Name,
      email: contact2Email,
      type: contact2Type,
      mobile: contact2Mobile,
      landline: contact2Landline,
    };
  }
  if (contact3Flag) {
    firmDto["contact3"] = {
      name: contact3Name,
      email: contact3Email,
      type: contact3Type,
      mobile: contact3Mobile,
      landline: contact3Landline,
    };
  }
  console.log(firmDto);
  if (state.action == "EDIT") {
    firmDto["id"] = state.firmDto.id;
  }

  return firmDto;
};

export const adminFirmEditDataModal = (values, clientId, firmId, formattedAutoAssignModality, selectedRadiologistMap, selectedSupervisorMap, selectedPacsList) => {

  var radiologistMap = [];
  for (let [key, value] of selectedRadiologistMap) {
    radiologistMap.push({
      userId: key,
      modalityIds: value,
    });
  }

  var supervisorMap = [];
  for (let [key, value] of selectedSupervisorMap) {
    supervisorMap.push({
      userId: key,
      modalityIds: value,
    });
  }

  const dto  = {
    clientAccessDto: {
      firmId: firmId,
      clientId: clientId,
      radiologistIdList: radiologistMap,
      supervisorIdList: supervisorMap
    },
    qcSettingDto: {
      firmId: firmId,
      clientId: clientId,
      qcEnabled: values.qcEnabled ? 1 : 0,
      twoSignaturesAllowed: values.twoSignaturesAllowed ? 1 : 0,
      modalityIds: values.modalityIds.filter(h => h != null).sort((a,b) => a-b)
    },
    historyAvailableDto: {
      firmId: firmId,
      clientId: clientId,
      historyAvailable: values.historyAvailable,
      modalityIds: values.historyModalityIds.filter(h => h!= null).sort((a,b) => a-b),
      clinicalNoteMandatory: values.clinicalNoteMandatory,
      subModalityMandatory: values.subModalityMandatory
    },
    autoAssignEnableDto: {
      firmId: firmId,
      clientId: clientId,
      autoAssignEnabled: values.autoAssignEnable ? 1 : 0,
      modalityIds: values.autoAssignModalityIds.filter(a => a != null).sort((a,b) => a-b),
      modalityWithSubModalityIds: formattedAutoAssignModality(),
      exactMatchEnabled: values.exactMatchEnable ? values.exactMatchEnable: false,
      pediatricAssignmentEnabled: values.pediatricAssignmentEnabled ? 1 : 0,
      selectedPediatricModalityId: values.selectedPediatricModalityId
    },
    disclaimerDto: {
      firmId: firmId,
      clientId: clientId,
      addPrintDisclaimer: values.addPrintDisclaimer,
      printDisclaimerText: values.printDisclaimerText === undefined ? "" : values.printDisclaimerText,
      accountWarning: values.accountWarning,
      priorityStudyCount: values.priorityCount,
      showPriorsStudies: values.showPriorsStudies
    },
    configureSettingDto: {
      firmId: firmId,
      clientId: clientId,
      branchCode: values.branchCode,
      showWord: values.showWord,
      selectedSubModalityListNumber: values.selectedSubModalityListNumber
    },
    configurePacsNodeDto: {
      firmId: firmId,
      clientId: clientId,
      selectedPacsNodes: selectedPacsList
    },
    unassignmentServiceDto: {
      firmId: firmId,
      clientId: clientId,
      firmEnableUnassignmentService: values.firmEnableUnassignmentService
    },
    firmSettingsDto:{
      enableSecondaryCapture: values.enableSecondaryCapture,
      enableGenkiStudyInference: values.enableGenkiStudyInference,      
    }
  }

  return dto;

}
